import "reflect-metadata";
import {inject, injectable} from "inversify";
import {TicketRepository} from "@dropDesk/domain/repositories/ticket/ticket.repository";
import {ListPaginationEntity} from "@dropDesk/domain/entities/common/list_pagination.entity";
import {BackupData} from "@dropDesk/domain/entities/ticket/backup/backup_data";

@injectable()
export class ListBackupTicketsUseCase {
    private _repository: TicketRepository;

    constructor(@inject(TicketRepository) repository: TicketRepository) {
        this._repository = repository;
    }

    public call(
        searchParam: string,
        page: number,
        limit: number,
    ): Promise<ListPaginationEntity<BackupData>> {
        return this._repository.listBackups(
            searchParam,
            page,
            limit,
        );
    }
}

